// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ratings[data-v-088a70e3]{background-image:url(/images/ratings-stars.png)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
